import { useLocation } from '@tanstack/react-router'

/**
 * Reads the globally-preserved `hideHeader` search param.
 *
 * `hideHeader` is registered on the root route and carried across every
 * navigation by the `retainSearchParams` middleware (see `src/app/__root.tsx`),
 * so any route that receives it — however deep in a redirect chain — hides the
 * app header. This hook is the single source of truth for reading it.
 */
export function useHideHeader() {
  const location = useLocation()
  return (location.search as { hideHeader?: boolean }).hideHeader === true
}
